module.exports = __webpack_public_path__ + "/images/logo-app-android-it.47cbd92.png";